import React from "react";

const IconMenu = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={33}
      height={33}
      viewBox="0 0 33 33"
      fill="none"
      {...props}
    >
      <rect
        x="4.35938"
        y="24.5758"
        width={24}
        height={2}
        rx={1}
        fill="#EF7D00"
      />
      <rect
        x="4.35938"
        y="16.0758"
        width={24}
        height={2}
        rx={1}
        fill="#EF7D00"
      />
      <rect
        x="4.35938"
        y="7.57581"
        width={24}
        height={2}
        rx={1}
        fill="#EF7D00"
      />
    </svg>
  );
};

export default IconMenu;
